import React, { Fragment } from 'react';
import styled from 'styled-components';
import Styles from './GoToApp.Styles';
import logo from '../../../assets/images/logo.svg';

const Container = styled.div`${Styles.container}`;
const ImgContainer  = styled.div`${Styles.imgContainer}`;
const CloseImg = styled.img`${Styles.closeImg}`;
const Text = styled.div`${Styles.text}`;
const PinkButton = styled.div`${Styles.pinkButton}`;

const GotoApp = ({locale, close}) => (
    <Fragment>
        <Container style={{backgoundColor: "pink"}}>
            <CloseImg src={'https://cdn-icons-png.flaticon.com/512/2997/2997911.png'} onClick={close}/>
            <ImgContainer style={{backgroundColor:"#3F2A55"}} >
                <img src={logo} width={20} height={15} />
            </ImgContainer>
            <Text>{locale === "en" ? "CBX is better in the app." : "CBX es mejor en la aplicación."}</Text>
            <PinkButton>
                <a href="https://qrco.de/bbjHg2">{locale === "en" ? "Download app" : "Descargar aplicación" }</a>
            </PinkButton>
        </Container>
    </Fragment>
  );


export default GotoApp;
